import "react-datepicker/dist/react-datepicker.css";
import "./style.css";

import { VStack, View, Input, InputField } from "@gluestack-ui/themed";
import { InputDatePickerProps } from "./types";
import DatePicker from "react-datepicker";
import { Icon } from "../Icon";
import { Text } from "../Text";

import { ptBR } from "date-fns/locale";
import { format } from "date-fns";
import { useState } from "react";
export const InputDatePicker = ({
  label,
  onChangeDate,
  defaultValue
}: InputDatePickerProps) => {
  const [date, setDate] = useState<Date | null>(defaultValue || new Date());
  return (
    <VStack $base-flex={1} space="xs">
      <Text color="white" family="roboto" fontWeight={500} fontSize="$sm">
        {label}
      </Text>
      <VStack flex={1} alignItems="center">
        <DatePicker
          locale={ptBR}
          dateFormat="dd/MM/yyyy"
          portalId="datepicker-popper"
          selected={date}
          onChange={(value: Date | null) => {
            onChangeDate(value);
            setDate(value);
          }}
          popperPlacement="bottom-end"
          customInput={
            <Input flex={1}>
              <InputField
                value={format(date as Date, "dd/MM/yyy", { locale: ptBR })}
              />
              <View position="absolute" right={16} alignSelf="center">
                <Icon name="calendar" color="$textLight500" size={16} />
              </View>
            </Input>
          }
        />
      </VStack>
    </VStack>
  );
};
